import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import { FaStar } from "react-icons/fa";

import avatar1 from "../../../assets/img/avatar/avatar-01.png";
import avatar2 from "../../../assets/img/avatar/avatar-02.png";
import avatar3 from "../../../assets/img/avatar/avatar-03.jpg";
import avatar4 from "../../../assets/img/avatar/avatar-04.png";

export default function AgentPerformance() {
  const [filter, setFilter] = useState("Monthly");

  const baseData = [
    { name: "Michael Johnson", rating: 4.6, time: "1.8h", rate: 70, img: avatar1 },
    { name: "Emily Davis", rating: 4.8, time: "1.4h", rate: 95, img: avatar2 },
    { name: "Robert Martinez", rating: 4.3, time: "1.1h", rate: 60, img: avatar3 },

    { name: "Megan Walker", rating: 4.5, time: "1.9h", rate: 80, img: avatar4 },
    { name: "Robert Martinez", rating: 4.3, time: "1.1h", rate: 60, img: avatar3 },

  ];

  const getData = () => {
    if (filter === "Today") {
      return baseData.map((d) => ({ ...d, rate: Math.max(d.rate - 15, 10) }));
    }
    if (filter === "Weekly") {
      return baseData.map((d) => ({ ...d, rate: Math.max(d.rate - 5, 10) }));
    }
    return baseData;
  };

  const data = getData();

  return (
    <Card className="agent-card-main h-100">
      {/* HEADER */}
      <div className="header">
        <h5>Agent Performance</h5>

        <Dropdown align="end">
          <Dropdown.Toggle className="dropdown-btn text-dark">
            <FiCalendar />
            <span>{filter}</span>
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-menu-custom">
            {["Today", "Weekly", "Monthly"].map((item) => (
              <Dropdown.Item
                key={item}
                active={filter === item}
                onClick={() => setFilter(item)}
                className="dropdown-item-custom"
              >
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* LIST */}
      {data.map((agent, i) => {
        const totalDots = 20;
        const filledDots = Math.round((agent.rate / 100) * totalDots);

        return (
          <div className="agent-row" key={i}>
            {/* LEFT */}
            <div className="left">
              <img src={agent.img} alt="" />
              <div>
                <h6>{agent.name}</h6>
                <p><FaStar /> {agent.rating}</p>
              </div>
            </div>

            {/* MIDDLE */}
            <div className="middle">
              <p>Avg Resolution Time</p>
              <h6>{agent.time}</h6>
            </div>

            {/* RIGHT */}
            <div className="right">
              <div className="top">
                <span>Resolution Rate</span>
                <span>{agent.rate}%</span>
              </div>

              <div className="dots">
                {[...Array(totalDots)].map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${index < filledDots ? "active" : ""}`}
                  />
                ))}
              </div>
            </div>
          </div>
        );
      })}

      <style>{`
        .agent-card-main {
          padding: 16px;
          border-radius: 5px;
          border: 2px solid #eee;
        }

        /* HEADER FIX */
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          margin-bottom: 16px;
        }

        .header h5 {
          font-size: 16px;
          margin: 0;
        }

        /* DROPDOWN FIX */
        .dropdown-btn {
          display: flex !important;
          align-items: center;
          gap: 6px;
          padding: 6px 12px !important;
          border-radius: 10px !important;
          border: 1px solid #e5e7eb !important;
          background: #fff !important;
          font-size: 13px;
          white-space: nowrap;
        }

        .dropdown-toggle::after {
          display: none !important;
        }

        .dropdown-menu-custom {
          border-radius: 12px !important;
          padding: 8px 0 !important;
          min-width: 150px;
        }

        .dropdown-item-custom {
          padding: 10px 16px !important;
        }

        .dropdown-item-custom.active {
          background: #ff6a00 !important;
          color: #fff !important;
        }

        /* ROW FIX */
        .agent-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          border: 1px solid #eee;
          border-radius: 12px;
          padding: 12px;
          margin-bottom: 12px;
        }

        .left {
          display: flex;
          align-items: center;
          gap: 10px;
          flex: 1;
          min-width: 140px;
        }

        .left img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .left h6 {
          font-size: 13px;
          margin: 0;
        }

        .left p {
          font-size: 12px;
          margin: 0;
          color: #777;
        }

        .middle {
          min-width: 110px;
        }

        .middle p {
          font-size: 11px;
          margin: 0;
        }

        .middle h6 {
          font-size: 13px;
          margin: 0;
        }

        .right {
          flex: 1;
          min-width: 150px;
        }

        .top {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          margin-bottom: 6px;
        }

        .dots {
          display: flex;
          gap: 4px;
          flex-wrap: wrap;
        }

        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #ddd;
        }

        .dot.active {
          background: #ff6a00;
        }

        /* MOBILE PERFECT FIX */
        @media (max-width: 768px) {
          .header {
            flex-direction: row;
            align-items: center;
          }

          .agent-row {
            flex-direction: column;
            align-items: flex-start;
          }

          .middle,
          .right {
            width: 100%;
          }

          .dots {
            justify-content: flex-start;
          }
        }
      `}</style>
    </Card>
  );
}